/**
 * @generated SignedSource<<e9fe2474abe776b4253329872def20d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type groupHeader_issueTableGrouping$data = {
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly __typename: string;
    readonly issueTypes?: ReadonlyArray<{
      readonly hierarchy: {
        readonly level: number | null | undefined;
      } | null | undefined;
      readonly issueTypeId: string | null | undefined;
    }>;
    readonly sprint?: {
      readonly state: JiraSprintState | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"categoryGroupHeader_issueTableGrouping" | "goalGroupHeader_issueTableGrouping" | "groupPickerGroupHeader_issueTableGrouping" | "issueTypeGroupHeader_issueTableGrouping" | "labelGroupHeader_issueTableGrouping" | "optionGroupHeader_issueTableGrouping" | "priorityGroupHeader_issueTableGrouping" | "sprintGroupHeader_issueTableGrouping" | "statusGroupHeader_issueTableGrouping" | "storyPointsGroupHeader_issueTableGrouping" | "userGroupHeader_issueTableGrouping" | "versionGroupHeader_issueTableGrouping">;
  } | null | undefined;
  readonly id: string;
  readonly issueCount: number | null | undefined;
  readonly " $fragmentType": "groupHeader_issueTableGrouping";
};
export type groupHeader_issueTableGrouping$key = {
  readonly " $data"?: groupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "groupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "kind": "ScalarField",
      "name": "issueCount"
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "FragmentSpread",
          "name": "priorityGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "userGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "statusGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "categoryGroupHeader_issueTableGrouping"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "optionGroupHeader_issueTableGrouping"
            },
            {
              "kind": "FragmentSpread",
              "name": "versionGroupHeader_issueTableGrouping"
            },
            {
              "kind": "FragmentSpread",
              "name": "labelGroupHeader_issueTableGrouping"
            },
            {
              "kind": "FragmentSpread",
              "name": "issueTypeGroupHeader_issueTableGrouping"
            },
            {
              "kind": "FragmentSpread",
              "name": "groupPickerGroupHeader_issueTableGrouping"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueTypes",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "issueTypeId"
                    },
                    {
                      "concreteType": "JiraIssueTypeHierarchyLevel",
                      "kind": "LinkedField",
                      "name": "hierarchy",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "level"
                        }
                      ]
                    }
                  ]
                }
              ],
              "type": "JiraJqlIssueTypeFieldValue"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "sprintGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "storyPointsGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "goalGroupHeader_issueTableGrouping"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "state"
                }
              ]
            }
          ],
          "type": "JiraJqlSprintFieldValue"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroup"
};

(node as any).hash = "46314a1c5a90d327bd89d01f78333319";

export default node;
